<script>
import { Line } from 'vue-chartjs'
import { createAnimationOptions } from "../../utils/chartAnimations";

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    animationType: {
      type: String,
      default: 'smooth'
    }
  },
  watch: {
    data: function () {
      this.renderLineChart();
    },
  },
  methods: {
    renderLineChart: function () {
      // Используем настройки анимации из утилиты для WordStat графиков
      const animationOptions = createAnimationOptions(this.animationType, 'line');
      const animatedOptions = {
        ...this.options,
        ...animationOptions
      };

      this.renderChart(this.chartData, animatedOptions, {
        responsive: true,
      });
    },
  },
  mounted () {
    this.renderLineChart();
  }
}
</script>

